import { useContext } from 'react';
import { DialogActions, DialogContext } from './DialogProvider';
function useDialog() {
    const { dispatch } = useContext(DialogContext);
    const removeDialog = () => {
        dispatch({
            type: DialogActions.HIDE_MODAL
        });
    };
    const enqueueDialog = (props) => {
        dispatch({
            type: DialogActions.SHOW_MODAL,
            modalProps: {
                ...props,
                onClose: (event, reason) => {
                    if (props.onClose) {
                        props.onClose(event, reason);
                    }
                    removeDialog();
                },
                onConfirm: () => {
                    if (props.onConfirm) {
                        props.onConfirm();
                    }
                    removeDialog();
                }
            }
        });
    };
    const toggleConfirmEnabled = () => {
        dispatch({
            type: DialogActions.TOGGLE_CONFIRM_ENABLED
        });
    };
    return { enqueueDialog, removeDialog, toggleConfirmEnabled };
}
export default useDialog;
